import { render, staticRenderFns } from "./SopimusYhteenveto.vue?vue&type=template&id=3f0b65c9&"
import script from "./SopimusYhteenveto.vue?vue&type=script&lang=js&"
export * from "./SopimusYhteenveto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0b65c9')) {
      api.createRecord('3f0b65c9', component.options)
    } else {
      api.reload('3f0b65c9', component.options)
    }
    module.hot.accept("./SopimusYhteenveto.vue?vue&type=template&id=3f0b65c9&", function () {
      api.rerender('3f0b65c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SopimusYhteenveto.vue"
export default component.exports